const windowGlobal = () => window as any

export { windowGlobal }
